import {
    Typography,
    withStyles,
    TypographyProps,
    makeStyles,
    createStyles
} from '@material-ui/core';
import HeartIcon from 'src/assets/icons/common/HeartIcon';
import HeartOutlineIcon from 'src/assets/icons/common/HeartOutlineIcon';
import StarIcon from 'src/assets/icons/common/StarIcon';

interface Props {
    text: string;
    classes?: AppClassNameProps & { icon?: string };
    textProp?: TypographyProps;
}

const MyStarIcon = withStyles(() => ({
    className: { marginRight: 4 }
}))(StarIcon);

const MyHeartIcon = withStyles(() => ({
    className: { marginRight: 4 }
}))(HeartIcon);

const MyOutlineHeartIcon = withStyles(() => ({
    className: { marginRight: 4 }
}))(HeartOutlineIcon);

const useStyles = makeStyles((_) =>
    createStyles({
        iconContainer: { display: 'flex', alignItems: 'center' }
    })
);

export const PopularModel = ({ text, classes, textProp }: Props) => {
    const modelClasses = useStyles();
    return (
        <div className={modelClasses.iconContainer}>
            <MyStarIcon className={classes?.icon} />
            <Typography className={classes?.text} {...textProp}>
                {text}
            </Typography>
        </div>
    );
};

export const FavoriteModel = ({ text, classes, textProp, empty }: Props & { empty?: boolean }) => {
    const modelClasses = useStyles();

    return (
        <div className={modelClasses.iconContainer}>
            {!empty ? (
                <MyHeartIcon className={classes?.icon} />
            ) : (
                <MyOutlineHeartIcon className={classes?.icon} />
            )}
            <Typography className={classes?.text} {...textProp}>
                {text}
            </Typography>
        </div>
    );
};
